import styled from 'styled-components'

export const Container = styled.div`
  padding: 1rem;
  background: ${({ theme }) => `rgb(${theme.component.background})`};
  border: ${({ theme }) => `1px solid rgb(${theme.grayscale[400]})`};
  max-width: 22rem !important;
  min-width: 15rem !important;
  min-height: 25rem;
  max-height: 35rem;
  margin: 0 auto;
  border-radius: 20px;
  cursor: pointer;

  h2 {
    font-size: 1rem;
    line-height: 1.5625rem;
    height: 8.5rem;
    font-weight: 700;
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
    max-width: 27rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-height: 1.4rem;
  }

  img {
    height: 4rem;

    background-color: #fff;
    border-radius: 5px;
  }
`

export const ImageContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  span {
    color: ${({ theme }) => `rgb(${theme.green[300]})`};
    padding: 0.2rem 0.72rem;
    border-radius: 3px;
    background: ${({ theme }) => `rgb(${theme.green[600]})`};
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 700;

    b {
      font-size: 1rem;
      line-height: 1.25rem;
      font-weight: 600;
    }
  }
`

export const ModuleWrapper = styled.div`
  height: 20px;
  svg {
    margin-right: 1rem;
  }
`

export const ProgressWrapper = styled.div`
  background: ${({ theme }) => `rgb(${theme.background.low})`};
  border-radius: 10px;
  padding: 1rem;
  margin: 1rem 0;

  span {
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    margin-bottom: 0.9rem;
  }
`

export const SeeMore = styled.button`
  width: 100%;
  padding: 0.5rem;
  margin: 1rem 0;
  border: ${({ theme }) => ` 1px solid rgb(${theme.primary.base})`};
  background: none;
  color: ${({ theme }) => `rgb(${theme.primary.base})`};
  border-radius: 8px;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 700;
`

export const SeeDetails = styled.button`
  width: 100%;
  padding: 0.5rem;
  margin: 1rem 0;
  border: ${({ theme }) => `1px solid rgb(${theme.blue[500]})`};
  background: none;
  color: ${({ theme }) => `rgb(${theme.blue[500]})`};
  border-radius: 8px;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 700;
  margin-top: 5.3rem;
`

export const FreemiumSpan = styled.span`
  padding: 0.4rem;
  background: rgba(255, 210, 51, 1);
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  color: rgba(26, 26, 26, 1);
`
